import { createFontWeightVariables as n, createLineHeightVariables as e, createFontSizeVariables as l } from "./highrise312.mjs";
const x = (t = "regular") => {
  const i = {
    regular: {
      fontWeight: n("regular")
    },
    medium: {
      fontWeight: n("medium")
    },
    semibold: {
      fontWeight: n("semibold")
    },
    bold: {
      fontWeight: n("bold")
    }
  };
  return i[t] || i.regular;
}, s = (t = "md", i = "text") => {
  const g = {
    "4xl": {
      fontSize: l("4xl", i),
      lineHeight: e("4xl", i)
    },
    "3xl": {
      fontSize: l("3xl", i),
      lineHeight: e("3xl", i)
    },
    "2xl": {
      fontSize: l("2xl", i),
      lineHeight: e("2xl", i)
    },
    xl: {
      fontSize: l("xl", i),
      lineHeight: e("xl", i)
    },
    lg: {
      fontSize: l("lg", i),
      lineHeight: e("lg", i)
    },
    md: {
      fontSize: l("md", i),
      lineHeight: e("md", i)
    },
    sm: {
      fontSize: l("sm", i),
      lineHeight: e("sm", i)
    },
    xs: {
      fontSize: l("xs", i),
      lineHeight: e("xs", i)
    },
    "2xs": {
      fontSize: l("2xs", i),
      lineHeight: e("2xs", i)
    },
    "3xs": {
      fontSize: l("3xs", i),
      lineHeight: e("3xs", i)
    },
    "4xs": {
      fontSize: l("4xs", i),
      lineHeight: e("4xs", i)
    }
  };
  return g[t] || g.md;
};
export {
  s as getTextSizeStyles,
  x as getTextWeightStyles
};
